import React from 'react';

import { getVisibleFields, groupFieldsBySection, sizeSuffix } from '@/components/DynamicFieldRenderer';
import { FieldRenderer } from '@/components/phone/FieldControls';
import { Card } from '@/components/phone/primitives';
import { Colors } from '@/components/phone/theme';

/**
 * A product's job card template, in phone controls.
 *
 * The desktop form is DynamicFieldForm: a two-column grid of shadcn controls
 * whose selects drop down from wherever the row happens to be. Below lg the
 * same fields, the same visibility rules and the same ply handling draw as the
 * supervisor app's 48px controls under their labels, so what the phone saves
 * onto the template is exactly what the desktop saves.
 */

function SpecField({ field, value, orderType, onChange, onPlyChange }) {
  const type = field.type || 'text';
  const label = (field.label?.replace(/\s*\([^)]*\)\s*$/, '') || field.name)
    + (field.name === 'size' ? sizeSuffix(orderType) : '');
  const wide = ['textarea', 'checkbox_group'].includes(type);

  const write = (next) => {
    if (field.name === 'ply' && onPlyChange) { onPlyChange(next); return; }
    // a number field stores a number, the same as the desktop form does
    onChange(field.name, type === 'number' && next !== '' ? Number(next) : next);
  };

  return (
    <div className={wide ? 'col-span-2' : ''}>
      <p className="mb-1.5 truncate text-[11px] font-medium" style={{ color: Colors.text.secondary }}>
        {label}
        {field.required && <span style={{ color: Colors.status.error }}> *</span>}
      </p>
      <FieldRenderer field={field} value={value} onChange={write} />
    </div>
  );
}

export default function PhoneSpecFields({ fields, values, onChange, onPlyChange, orderType }) {
  const sections = Object.entries(groupFieldsBySection(getVisibleFields(fields, values)));
  if (sections.length === 0) return null;

  return sections.map(([sectionName, sectionFields]) => (
    <Card key={sectionName} className="mt-3" title={sectionName} testID={`section-${sectionName}`}>
      <div className="grid grid-cols-2 gap-x-3 gap-y-4">
        {sectionFields.map((field) => (
          <SpecField
            key={field.name}
            field={field}
            value={values[field.name]}
            orderType={orderType}
            onChange={onChange}
            onPlyChange={onPlyChange}
          />
        ))}
      </div>
    </Card>
  ));
}
